module.exports = __webpack_public_path__ + "static/media/mask-demo.7886405c.mp4";